import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import PeriodPicker from 'pages/parts/PeriodPicker'
import SmsCounter from 'pages/parts/SmsCounter'
import { cleanSmsText } from 'helpers/sms'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'

import { returnSign, formatDate } from "helpers/helpers";
import { POST, PUT, GET, httpOk } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [smsTypes, setSmsTypes] = useState([])
	const [isSmsCatalog, setIsSmsCatalog] = useState(false)
	const [smsCatalog, setSmsCatalog] = useState([])
	const [selectedItem, setSelectedItem] = useState({ 'text': '' })
	const [showModal, setShowModal] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const initialFilterData = { pos_id: null, search: '' }
	const initialPagination = { url: '/sms-templates', response: null }
	const {
		filterData,
		appliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetFilters,
	} = useFilterSearchPagination({ initialFilterData, initialPagination })
	const [data, setData] = useState([])

	async function searchWithFilter(customFilterData = filterData) {
		var filterDataCopy = { ...customFilterData }
		var filterUrl = "/sms-templates"
		var urlParams = ""
		checkFilter()

		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/sms-templates${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
			setDropdownIsOpen(false)
		}
	}

	async function createUpdate(e) {
		e.preventDefault();

		var response
		if (selectedItem.id) {
			response = await PUT('/sms-templates', selectedItem, { loader: true })
		} else {
			response = await POST('/sms-templates', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModal(false)
		}
	}

	function toggleModal(bool, item = {}) {
		if (bool) {
			setShowModal(true)
		} else {
			setShowModal(false)
		}
		setSelectedItem(item)
	}

	function resetFilter() {
		resetFilters({ ...initialFilterData }, searchWithFilter)
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			// managed by hook when filters are reset
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handlePaginate(page) {
		const nextFilterData = { ...filterData, page }
		paginate(page)
		searchWithFilter(nextFilterData)
	}

	async function getSmsTypes() {
		const response = await GET('/helper/sms-types')
		if (httpOk(response)) setSmsTypes(response.data)
	}

	// У Mison SMS свои шаблоны заведения не отправляются и не редактируются: страница
	// показывает каталог Mison только для чтения, шаблон выбирают при отправке
	async function getSmsCatalogMode() {
		const response = await GET('/sms/catalog?usage=marketing,callcenter,debt,debt_org')
		if (httpOk(response)) {
			setIsSmsCatalog(!!response.data?.is_template_only)
			setSmsCatalog(response.data?.data || [])
		}
	}

	useEffect(() => {
		getSmsTypes()
		getSmsCatalogMode()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	if (isSmsCatalog) {
		return (
			<>
				<div className="page-header d-flex justify-content-between">
					<h4 className="vertical-center">
						{t('sms_templates')} [{smsCatalog.length}]
					</h4>
				</div>

				<div className="alert alert-info py-2 px-3" style={{ fontSize: '12px' }}>{t('sms_own_templates_unused')}</div>

				<div className="card">
					<div className="card-body">
						<div className="table-responsive">
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '15%' }}>{t('sms_template')}</th>
										<th style={{ 'width': '12%' }}>{t('type')}</th>
										<th style={{ 'width': '36%' }}>{t('sms_locale_ru')}</th>
										<th style={{ 'width': '36%' }}>{t('sms_locale_uz')}</th>
									</tr>
								</thead>
								<tbody>
									{smsCatalog.map((item, index) => (
										<tr key={item.code}>
											<td className="text-center">{index + 1}</td>
											<td>{item.title}</td>
											<td>{t(`sms_group_${item.group_code}`, item.group_code)}</td>
											<td>{item.texts?.ru?.text || '—'}</td>
											<td>{item.texts?.uz_latn?.text || '—'}</td>
										</tr>
									))}
									{smsCatalog.length === 0 &&
										<tr><td colSpan="5" className="text-center text-muted">{t('sms_catalog_empty')}</td></tr>
									}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</>
		)
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('sms_templates')} [{data.total}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => setShowModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, searchWithFilter)}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													withTime={false}
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
													onChange={(period) => patchFilterData(period)}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => applyFilters(searchWithFilter)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(appliedFilterData.start_date || appliedFilterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{appliedFilterData.start_date &&
											<span>{formatDate(appliedFilterData.start_date)}</span>
										}
										{(appliedFilterData.start_date && appliedFilterData.end_date) &&
											<span>|</span>
										}
										{appliedFilterData.end_date &&
											<span>{formatDate(appliedFilterData.end_date)}</span>
										}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '10%' }}>{t('name2')}</th>
									<th style={{ 'width': '40%' }}>{t('text')}</th>
									<th style={{ 'width': '30%' }}></th>
									<th style={{ 'width': '10%' }} className="text-center">{t('type')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
									<th style={{ 'minWidth': '33px' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td>
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td>{item.text}</td>
										<td></td>
										<td className="text-center text-nowrap">{item.sms_type_name}</td>
										<td className="text-center text-nowrap">
											{formatDate(item.created_at, 'dd.MM.yy HH:mm')}
										</td>
										<td>
											<div className="table-action-button table-action-primary-button"
												onClick={() => toggleModal(true, item)}>
												<i className="uil-edit-alt"></i>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('create')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								autoComplete="off"
								value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })}
							/>
						</div>

						<div className="form-group">
							<label>{t('type')}<span className="required-mark">*</span></label>
							<Select
								options={smsTypes}
								value={smsTypes.find(option => option.id === selectedItem.sms_type_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'sms_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group">
							<label>{t('text')}</label>
							{/* Вырезаем только эмодзи и управляющие символы. Раньше фильтр пропускал лишь
								ASCII и а-я и молча съедал ё, ў, қ, ғ, ҳ — узбекский текст терял буквы */}
							<textarea className="form-control" rows="5" maxLength={500}
								value={selectedItem.text ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'text': cleanSmsText(e.target.value) })}>
							</textarea>
							<SmsCounter text={selectedItem.text} />
							<div className="mt-1">{t('sms_variable_username')} - <b>:username</b></div>
							<div>{t('sms_variable_promo_code')} - <b>:promo_code</b></div>
							{/* Типы 5/6 — долг клиента и организации: сумму подставит рассылка должникам */}
							{[5, 6].includes(selectedItem.sms_type_id) &&
								<div>{t('sms_variable_debt_amount')} - <b>:debt_amount</b></div>
							}
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index